

const withImportMap = (importMaps, userName) => {

    userName = userName.trim().toLowerCase();

    if (importMaps.usersByName[userName]) return importMaps.usersByName[userName];
    if (importMaps.usersByEmail[userName]) return importMaps.usersByEmail[userName];

    return null;
}

// old should not be used
const withoutImportMap = (userName) => {

    // console.log("mapByUserName", userName)

    const companyUsers = gd.session.companyUsers;

    let userId = null;

    if (companyUsers) {

        const companyUser = _.find(companyUsers.models,companyUser=>{
            // console.log("    ", companyUser.user.name.toLowerCase(), userName.trim().toLowerCase(),    companyUser.user.name.toLowerCase()===userName.trim().toLowerCase())
            return companyUser.user.name.toLowerCase().trim()===userName.trim().toLowerCase();
        });

        if (companyUser) return companyUser.user.id;

    }

    return null;

}



export default function mapByUserName(companyId, userName) {

    if (gd.getApp().maps) {
        return withImportMap(gd.getApp().maps, userName)
    } else {
        return withoutImportMap(userName)
    }

}
